import * as React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import TourTags from "./tourTags"
import TourPrice from "./tourPrice";

const TourAdItem = ({ blok, full_slug }) => {
  if (!blok) return null;
  // console.log(blok);
  const bgImage = blok.bannerBgImage?.filename ? 
    `url(${blok.bannerBgImage?.filename})` : 
    'url("https://img.freepik.com/free-photo/cherry-blossoms-spring-chureito-pagoda-fuji-mountain-japan_335224-213.jpg")';

  
  return (
    <a href={`/${full_slug}`} {...storyblokEditable(blok)} 
      className="w-full max-w-[700px] min-h-[200px] m-4 cursor-pointer rounded-md bg-cover bg-center hover:scale-105 transition hover:shadow-md"
      style={{ 'backgroundImage': `${bgImage}` }}>
        
      <div className="flex flex-col h-full bg-black bg-opacity-20 text-white text-left p-4">
        <div className="text-sm mt-4 mb-2">{blok.tourSubHeading}</div>
        <div className="font-serif font-bold mb-4">{blok.tourTitle}</div>
        <TourTags blok={blok} />
        <div className="font-bold mt-5"><TourPrice currency={blok.currency} price={blok.price} /></div>

      </div>
      
    </a>
  )
}

const RelatedTourItem = ({ blok }) => {
  return (
    <div className="p-5 flex flex-col items-center">
      {
      blok.tourAdItems.map((item, index) => (
        <TourAdItem blok={item.content} full_slug={item.full_slug} key={index} />
      ))
      }
    </div>
  )
}

export default RelatedTourItem
